import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  IconButton,
  Typography,
  Box,
  Select,
  MenuItem,
} from "@mui/material";
import {
  selectError,
  selectIsLoading,
  selectSingleSensori,
  selectWeatherData,
} from "../../../features/sensori/sensoriSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchWeatherData } from "../../../features/sensori/sensoriThunk";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const CustomPagination = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => (
  <Box
    display="flex"
    justifyContent="flex-end"
    alignItems="center"
    p={2}
    className="custom_pagination"
  >
    <Typography variant="body2" color="text.secondary" mr={2}>
      Righe per pagina:
    </Typography>
    <Select
      className="customSelect"
      value={rowsPerPage}
      onChange={onRowsPerPageChange}
      size="small"
    >
      <MenuItem value={5}>5</MenuItem>
      <MenuItem value={10}>10</MenuItem>
    </Select>
    <Typography variant="body2" color="text.secondary">
      {`${page * rowsPerPage + 1}-${Math.min(
        (page + 1) * rowsPerPage,
        count
      )} di ${count}`}
    </Typography>
    <div className="iconBtn">
      <IconButton
        onClick={(e) => onPageChange(e, page - 1)}
        disabled={page === 0}
      >
        <KeyboardArrowLeftIcon />
      </IconButton>
      <IconButton
        onClick={(e) => onPageChange(e, page + 1)}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
      >
        <KeyboardArrowRightIcon />
      </IconButton>
    </div>
  </Box>
);

const LocationTable = ({ filterTab, singleData }) => {
  const dispatch = useDispatch();
  const weatherData = useSelector(selectWeatherData);
  const isLoading = useSelector(selectIsLoading);
  const error = useSelector(selectError);
  const singleId = useSelector(selectSingleSensori)

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const locationTable = weatherData?.locationTable || [];
  const headerarray= singleId.company_id===35 && singleId.sensore_name === 'seafish'?[
    "Temperatura",
    "Pulizia Acqua",
    "pH Acqua",
    // "Vapor Pressure Deficit",
    // "Ultima rilevazione",
    // "Ubicazione",
    "Azioni"
  ]:["Temperatura",
    "Umidità",
    "punto di rugiada",
    "Vapor Pressure Deficit",
    "Ultima rilevazione",
    "Ubicazione",
    "stato",
    "Azioni",]
  useEffect(() => {
    if (filterTab && singleData) {
      dispatch(fetchWeatherData({
        filter: filterTab.toLowerCase(),
        sensore_name: singleData?.sensore_name
      }))
        .then((res) => {
          console.log(`Fetched data for ${filterTab}:`, res);
        })
        .catch((err) => {
          console.error("Failed to fetch data:", err);
        });
    }
  }, [dispatch,filterTab, singleData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = rowsPerPage > 0
    ? locationTable.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    : locationTable;

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <TableContainer className="TemperaturaTable">
        <Table>
          <TableHead>
            <TableRow>
              {headerarray.map((header) => (
                <TableCell key={header}>{header}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((row, index) => (
              <TableRow key={index}>
                {console.log(row,"lllllll")}
                {Object.values(row)
                  .map((value, i) => (
                    <TableCell key={i}>{value}</TableCell>
                  ))}
                <TableCell>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#32CD32",
                      color: "white",
                      "&:hover": { backgroundColor: "#2E8B57" },
                    }}
                  >
                    {row.stato}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {locationTable.length > 0 && (
          <CustomPagination
            count={locationTable.length}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </TableContainer>
    </>
  );
};

export default LocationTable;